module.exports = __webpack_public_path__ + "img/parliament-8.169b5a8c.webp";